import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    backgroundColor: '#f2f2f2',
    paddingHorizontal: 15,
  },
});
